import { IsNotEmpty } from "class-validator";

export class AccountCodeDTO {
  @IsNotEmpty({ message: 'Le nom du code comptable est requis.' })
  name: string;

  @IsNotEmpty({ message: 'Le code comptable est requis.' })
  code: string;
}